/**
 * Builds a code → obligation(s) map for efficient question lookups.
 * Multiple obligations sharing the same code are grouped into an array.
 *
 * @param {Array<Object>} obligations
 * @returns {Record<string, Object[]>}
 */
export const buildComplianceObligationsMap = (obligations = []) => {
    if (!Array.isArray(obligations) || obligations.length === 0) {
        return {};
    }

    return obligations.reduce((map, obligation) => {
        if (!obligation?.code) {
            return map;
        }

        if (!map[obligation.code]) {
            map[obligation.code] = [];
        }

        map[obligation.code].push(obligation);

        return map;
    }, {});
};

/**
 * Merges obligation lists from AI Risk Assessment and CE Conformity sources.
 *
 * @param {...Array<Object>} obligationLists
 * @returns {Array<Object>}
 */
export const mergeComplianceObligations = (...obligationLists) => {
    return obligationLists
        .filter(Array.isArray)
        .flat()
        .filter((obligation) => !!obligation?.code);
};
